import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarRef,
} from '@angular/material/snack-bar';
import { SnackbarTypeEnum } from 'src/app/data/models/enum/snackbar-type.enum';

@Component({
  selector: 'app-custom-snackbar',
  templateUrl: './custom-snackbar.component.html',
  styleUrls: ['./custom-snackbar.component.scss'],
})
export class CustomSnackbarComponent implements OnInit {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
    public snackBarRef: MatSnackBarRef<CustomSnackbarComponent>
  ) {}

  snackType = '';
  ngOnInit(): void {
    if (this.data.snackType) this.snackType = this.data.snackType;
    if (this.snackType != '') this.setToastIconImage();
  }

  toastIconImage = '';
  private setToastIconImage() {
    switch (this.data.snackType) {
      case SnackbarTypeEnum.SUCCESS:
        this.toastIconImage = '../../../../assets/icons/toast-icon-success.svg';
        break;
      case SnackbarTypeEnum.ERROR:
        this.toastIconImage = '../../../../assets/icons/toast-icon-error.svg';
        break;
      case SnackbarTypeEnum.WARNING:
        this.toastIconImage = '../../../../assets/icons/toast-icon-warning.svg';
        break;
      case SnackbarTypeEnum.INFO:
        this.toastIconImage = '../../../../assets/icons/toast-icon-info.svg';
        break;
    }
  }

  onCloseClick() {
    this.snackBarRef.dismiss();
  }
}
